<template>
  <PageHeaderLayout v-show='this.$route.matched.length===2'>
    <div class='main-page-content'>
      <el-card class='box-card'>
        <div style='text-align: center;font-weight: bold;font-size: 18px;margin-bottom: 12px'>
          <el-button :loading='loading' icon='el-icon-refresh' type='text' style='float: left' @click='handleRefresh'>
            刷新
          </el-button>
          <span>
            全员页面在线人员分析（<span style='color: #ff3176'>{{ totalUsers }}</span> 人在线，分布于
            <span style='color: #ff3176'>{{ totalPages }}</span> 个页面）
          </span>
          <el-checkbox style='float: right' v-model='autoRefresh' @change='autoRefreshChanged'>
            每15秒自动刷新
          </el-checkbox>
        </div>

        <div style='margin-bottom: 10px'>
          <el-input
            v-model='keyword'
            placeholder='输入页面路径关键字筛选'
            clearable
            prefix-icon='el-icon-search'
            style='width: 320px'
            @input='keywordChanged'
          />
          <span style='margin-left: 12px;color: #909399;font-size: 12px'>
            展开页面行可查看该页面具体在线人员
          </span>
        </div>

        <el-table
          v-loading='loading'
          :data='filteredList'
          row-key='path'
          empty-text='暂无在线页面数据'
          border
        >
          <el-table-column type='expand' width='40'>
            <template slot-scope='scope'>
              <div class='page-users'>
                <template v-if='scope.row.users && scope.row.users.length'>
                  <div v-for='(u, idx) in scope.row.users' :key='idx' class='page-user-item'>
                    <el-image
                      :src='u.avatar || defaultAvatar'
                      :preview-src-list='[u.avatar || defaultAvatar]'
                      style='width: 36px;height: 36px;border-radius: 50%;flex-shrink: 0'
                      fit='cover'
                    />
                    <div class='page-user-info'>
                      <div class='page-user-name'>{{ u.nickname }}</div>
                      <div class='page-user-detail'>
                        <span v-if='u.browser || u.platform'>{{ [u.browser, u.platform, u.device].filter(Boolean).join(' / ') }}</span>
                        <span v-if='u.ip'> IP：{{ u.ip }}</span>
                        <span v-if='u.login_at'> 上线：{{ u.login_at }}</span>
                      </div>
                    </div>
                  </div>
                </template>
                <el-empty v-else description='该页面暂无在线用户' :image-size='60' />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop='path' label='页面路径' min-width='260' show-overflow-tooltip>
            <template slot-scope='scope'>
              <el-link type='primary' :underline='false' @click='openInNewTab(scope.row.path)'>
                {{ scope.row.title || scope.row.path }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop='count' label='在线人数' width='120' align='center'>
            <template slot-scope='scope'>
              <el-tag :type='scope.row.count > 0 ? "success" : "info"' size='mini'>
                {{ scope.row.count }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label='在线人员（前3位）' min-width='260'>
            <template slot-scope='scope'>
              <template v-if='scope.row.users && scope.row.users.length'>
                <el-tag
                  v-for='(u, idx) in scope.row.users.slice(0, 3)'
                  :key='idx'
                  style='margin-right: 4px'
                  size='mini'
                >
                  {{ u.nickname }}
                </el-tag>
                <span
                  v-if='scope.row.users.length > 3'
                  style='color: #909399;font-size: 12px'
                >
                  +{{ scope.row.users.length - 3 }}
                </span>
              </template>
              <span v-else style='color: #909399'>-</span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
  </PageHeaderLayout>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'

export default {
  name: 'PageOnlineAdmin',
  components: { PageHeaderLayout },
  data() {
    return {
      loading: false,
      autoRefresh: true,
      list: [],
      totalUsers: 0,
      totalPages: 0,
      keyword: '',
      defaultAvatar: require('@/assets/avatar_default.png'),
      timer: null,
      routeTitleMap: {}
    }
  },
  computed: {
    filteredList() {
      const keyword = (this.keyword || '').trim().toLowerCase()
      if (!keyword) {
        return this.list
      }
      return this.list.filter((item) => String(item.path || '').toLowerCase().indexOf(keyword) > -1)
    }
  },
  mounted() {
    this._buildRouteTitleMap()
    this.handleRefresh()
    this.autoRefreshChanged(true)
  },
  beforeDestroy() {
    this.stopTimer()
    if (this.$globalWs) {
      this.$globalWs.rmEvt('ev_page_users')
      this.$globalWs.sendMsg({ event: 'cancel_subscribe_page_users' })
      this.$globalWs.sendMsg({ event: 'update_page', data: { path: '' } })
    }
  },
  methods: {
    /**
     * 拉取全员页面在线状态
     */
    async getPageOnlineUsers() {
      this.loading = true
      try {
      // 注意：api/index.js 中 user 模块是 ...user 展开到根对象的，因此直接 this.$api.getPageOnlineUsers()
      const data = await this.$api.getPageOnlineUsers()
        this.list = data.list || []
        this.totalUsers = data.total_users || 0
        this.totalPages = data.total_pages || 0
        // 为每个页面补充可读标题
        this.list.forEach((item) => {
          item.title = this._resolveTitle(item.path) || item.path
        })
      } catch (e) {
        // 请求错误由全局拦截器处理
      } finally {
        this.loading = false
      }
    },
    handleRefresh() {
      // 顺便向 WS 上报当前所在页面（进入本页也计入页面在线）
      if (this.$globalWs) {
        this.$globalWs.sendMsg({ event: 'subscribe_page_users' })
        this.$globalWs.sendMsg({ event: 'update_page', data: { path: this.$route.path } })
      }
      this.getPageOnlineUsers()
    },
    autoRefreshChanged(val) {
      if (val) {
        this.startTimer()
      } else {
        this.stopTimer()
      }
    },
    startTimer() {
      this.stopTimer()
      this.timer = setInterval(() => {
        this.getPageOnlineUsers()
      }, 15000)
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    keywordChanged() {
      // 由计算属性驱动筛选，此方法保证 @input 有处理器
    },
    openInNewTab(path) {
      if (!path) {
        return
      }
      const { href } = this.$router.resolve(path)
      window.open(href, '_blank')
    },
    /**
     * 构建 完整路径 => 菜单标题 的映射（遍历路由树）
     */
    _buildRouteTitleMap() {
      const walk = (routes, parentPath) => {
        routes.forEach((route) => {
          const fullPath = this._joinPath(parentPath, route.path)
          if (route.meta && route.meta.title) {
            this.routeTitleMap[fullPath] = route.meta.title
          }
          if (route.children && route.children.length) {
            walk(route.children, fullPath)
          }
        })
      }
      walk(this.$router.options.routes || [], '')
    },
    _joinPath(parent, child) {
      let joined
      if (!parent) {
        joined = child || ''
      } else if (!child) {
        joined = parent
      } else {
        joined = `${String(parent).replace(/\/+$/, '')}/${String(child).replace(/^\/+/, '')}`
      }
      // 统一以 / 开头，与 $route.path 保持一致，便于标题匹配
      return joined.startsWith('/') ? joined : `/${joined}`
    },
    _resolveTitle(path) {
      if (!path) {
        return ''
      }
      // 逐级缩短路径，取最接近的已注册标题
      let p = path
      while (p) {
        if (this.routeTitleMap[p]) {
          return this.routeTitleMap[p]
        }
        const idx = p.lastIndexOf('/')
        if (idx <= 0) {
          break
        }
        p = p.slice(0, idx)
      }
      return ''
    }
  }
}
</script>

<style scoped>
.page-users {
  display: flex;
  flex-wrap: wrap;
  padding: 8px 16px 8px 40px;
  background: #fafafa;
}

.page-user-item {
  display: flex;
  align-items: center;
  width: 300px;
  margin: 4px 8px 4px 0;
  padding: 6px 8px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fff;
}

.page-user-info {
  margin-left: 10px;
  min-width: 0;
}

.page-user-name {
  font-weight: 600;
  color: #333;
  word-break: break-all;
}

.page-user-detail {
  font-size: 12px;
  color: #909399;
  word-break: break-all;
}
</style>

